import { render, staticRenderFns } from "./NewsDetail3.vue?vue&type=template&id=4159549b&scoped=true"
var script = {}
import style0 from "./NewsDetail3.vue?vue&type=style&index=0&id=4159549b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4159549b",
  null
  
)

export default component.exports